import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors }: Theme) => createStyles({
  icon: {
    display: 'flex',
    alignItems: 'center',
    '& path': {
      fill: colors.uIIconBase,
    },
  },
});

export default styles;
